<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12 2c-5.525 0-10 4.475-10 10s4.475 10 10 10 10-4.475 10-10-4.475-10-10-10zm5 13.585-1.415 1.415-3.585-3.585-3.585 3.585-1.415-1.415 3.585-3.585-3.585-3.585 1.415-1.415 3.585 3.585 3.585-3.585 1.415 1.415-3.585 3.585z"
    />
  </svg>
</template>
